'use strict';
require('./edit.order.time.scss');

class EditOrderTimeController {
    /*@ngInject*/
    constructor($mdDialog, utils, orderStore, orderId) {
        "ngInject";
        _.extend(this, {
            $mdDialog: $mdDialog,
            utils: utils,
            orderStore: orderStore
        });

        this.order = {
            id: orderId
        };

        [this.minMoveDate, this.formattedMinMoveDate] = this.utils.getMinMoveDate();
        this.moveDate = this.utils.getDefaultMoveDate();

    }

    hide() {
        this.$mdDialog.hide();
    }

    cancel() {
        this.$mdDialog.cancel();
    }

    change() {
        this.order.order_time = parseInt(this.moveDate.getTime() / 1000, 10);
        let deferred = this.orderStore.saveOrder(this.order)
            .then(
                (order) => {
                    this.$mdDialog.hide(this);
                },
                (error) => {
                    console.log(error);
                }
            );

        this.utils.busyDeferred(this, deferred, '__busy');
    }
}

export default EditOrderTimeController;


// WEBPACK FOOTER //
// ./client/app/common/popup.component/edit.order.time/edit.order.time.controller.js